import type {} from "@next/third-parties/google";
import { AddEventToDataLayerType } from "@website/tracking/tracking.types";
import { getChannel } from "@website/utils/channel/get-channel";
import { isSSR } from "@website/utils/is-ssr";
import isArray from "lodash-es/isArray";

export const addEventToDataLayer: AddEventToDataLayerType = (
  event,
  dataLayerData
) => {
  if (isSSR()) return;
  window.dataLayer ||= [];
  const passedData =
    getChannel() === "b2b" && isArray(dataLayerData?.items)
      ? dataLayerData?.items.map((item) => ({
          ...item,
          ...(item.item_brand && { item_brand: "b2b" })
        }))
      : dataLayerData;

  window.dataLayer.push({ event, ecommerce: passedData });
};

export const addEventToDataLayerGT3: AddEventToDataLayerType = (
  event,
  dataLayerData
) => {
  if (isSSR()) return;
  window.dataLayer ||= [];
  window.dataLayer.push({ event, ...dataLayerData });
};
